<template>
  <div class="padded">

    <!-- @TODO fix for assets -->
    <tickets-table
     :site-id="rowData.site_id"
     :asset-id="assetId"
     :owner-id="rowData.organisation_id"
     process-key="equip-ticket"
     :hide-site="true" />

</div>
</template>


<script>

import TicketsTable from '@/components/tables/TicketsTable'

export default {
  components: {
    TicketsTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    assetId: {
      type: Number
    }
  }

}

</script>
